import styled from "styled-components";

export const AuthenticateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .infoComplete {
    display: flex;
    align-items: center;
    flex-direction: column;
    background: ${({ theme }) => theme.backgrounds.defaultGradient};
    padding: 0.75rem 0.625rem;
    border-radius: 5px;
    padding-top: 4rem;
    height: 40rem;
    width: 40rem;
    gap: 3rem;

    div {
      display: flex;
      align-items: center;
    }

    section {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.875rem;
    }

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
    }

    h3 {
      font-weight: 600;
      line-height: 2.5rem;
      font-size: 1.5rem;
    }

    .qrcode {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #ffffff;
      padding: 2rem;
      border-radius: 5px;
    }

    .loader {
      margin: 6.5rem;
      border: 5px solid #000000;
      border-top: 5px solid #ffffff;
      border-radius: 50%;
      width: 72px;
      height: 72px;
      animation: spin 1.5s linear infinite;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    p {
      padding: 0.75rem 0.625rem;
      font-weight: 400;
      font-size: 1.25rem;
      line-height: 128%;
      text-align: center;

      span {
        font-weight: 700;
      }
    }

    @media (max-width: 725px) {
      display: none;
    }
  }

  .btnDeepLink {
    align-items: center;
    flex-direction: column;
    padding: 0.75rem 0.625rem;
    border: 1px solid #dedede;
    width: 100%;
    border-radius: 5px;

    a {
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 0.75rem 0.625rem;
      background: ${({ theme }) => theme.backgrounds.defaultGradient};
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      border: none;
      width: 100%;
      text-decoration: none;
    }

    h3 {
      font-weight: 600;
      line-height: 1.5rem;
      font-size: 1rem;
    }

    p {
      padding: 0.75rem 0.625rem;
      font-weight: 400;
      font-size: 0.875rem;
      line-height: 128%;
      text-align: center;

      span {
        font-weight: 700;
      }
    }
  }
`;
